import { JobItem } from 'domains/workspaceDomain';
import { CommonNotes } from '../../common';
import './SupplierNotes.less';

const SupplierNotes = (jobDate: JobItem) => {
  return (
    <div className="supplier-notes-card">
      <CommonNotes {...jobDate} />
    </div>
  );
};

export default SupplierNotes;
